module.exports = __webpack_public_path__ + "img/lunch_title--extra.8a7098df.png";